import axios from "../../utils/axios";

/**
 * Livraison (Delivery) Service
 * Connects to /api/admin/livraisons endpoints
 */

// Get all deliveries with optional filters
export const get_all_livraisons = async ({ query, order_by, status, employee_id, page = 1, limit = 50 }, month) => {
    let url = `/admin/livraisons?page=${page}&limit=${limit}`;

    if (query) url += `&query=${encodeURIComponent(query)}`;
    if (order_by) url += `&order_by=${order_by}`;
    if (status && status !== 'all') url += `&status=${status}`;
    if (employee_id) url += `&employee_id=${employee_id}`;

    // Filter by date range based on month
    if (month) {
        const year = new Date().getFullYear();
        const date_from = new Date(year, month - 1, 1).toISOString();
        const date_to = new Date(year, month, 0, 23, 59, 59).toISOString();
        url += `&date_from=${date_from}&date_to=${date_to}`;
    }

    const response = await axios.get(url);
    return response.data;
};

// Get single delivery by ID
export const get_livraison = async (id) => {
    const response = await axios.get(`/admin/livraisons/${id}`);
    return response.data;
};

// Create a new delivery
export const create_livraison = async (payload) => {
    const response = await axios.post(`/admin/livraisons`, payload);
    return response.data;
};

// Update a delivery
export const update_livraison = async (id, payload) => {
    const response = await axios.put(`/admin/livraisons/${id}`, payload);
    return response.data;
};

// Delete a delivery
export const delete_livraison = async (id) => {
    const response = await axios.delete(`/admin/livraisons/${id}`);
    return response.data;
};

// Bulk update status
export const bulk_update_status = async (ids, status) => {
    const response = await axios.put(`/admin/livraisons/bulk/status`, { ids, status });
    return response.data;
};

// Get all statuses
export const get_all_statuses = async () => {
    const response = await axios.get(`/admin/statuses`);
    return response.data;
};

// Create a new status
export const create_status = async (payload) => {
    const response = await axios.post(`/admin/statuses`, payload);
    return response.data;
};

// Update a status
export const update_status = async (id, payload) => {
    const response = await axios.put(`/admin/statuses/${id}`, payload);
    return response.data;
};

// Delete a status
export const delete_status = async (id) => {
    const response = await axios.delete(`/admin/statuses/${id}`);
    return response.data;
};
